<template>

  <el-main
    class="main_content"
    style="padding: 0"
  >
    <div class="cont_navs_header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>
          <a>资金管理</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <a @click="jumpTo('/onLinePayList')">支付宝微信交易记录</a>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="contain_div">
      <div class="contain_header clr">
        <el-form
          :inline="true"
          class="m-search"
          size='small'
          :model="filters"
        >
          <el-form-item label='代理信息'>
            <el-input
              style="width:500px"
              v-model="filters.title"
              placeholder="请输入姓名或者手机号"
            >

            </el-input>
          </el-form-item>

          <el-form-item label="查询时间">
            <el-form-item prop="startTime">
              <el-date-picker
                type="date"
                placeholder="选择开始日期"
                v-model="filters.startTime"
                style="width: 100%;"
              ></el-date-picker>
            </el-form-item>
            <span style="display: inline-block;margin-right: 9px;">-</span>
            <el-form-item prop="endTime">
              <el-date-picker
                type="date"
                placeholder="选择结束日期"
                v-model="filters.endTime"
                style="width: 100%;"
              ></el-date-picker>
            </el-form-item>

          </el-form-item>
          <el-form-item label="类型">
            <el-select
              v-model="filters.infoType"
              clearable
            >
              <el-option
                label="充值"
                value="1"
              ></el-option>
              <el-option
                label="购进"
                value="2"
              ></el-option>
              <el-option
                label="支付保证金"
                value="3"
              ></el-option>
              <el-option
                label="补交保证金"
                value="4"
              ></el-option>
              <el-option
                label="发布服务订单"
                value="5"
              ></el-option>
              <el-option
                label="加价服务订单"
                value="6"
              ></el-option>
              <el-option
                label="补货"
                value="9"
              ></el-option>
              <el-option
                label="支付学习费"
                value="16"
              ></el-option>
              <el-option
                label="支付换货订单"
                value="21"
              ></el-option>
              
            </el-select>
          </el-form-item>

          <el-form-item label="状态">
            <el-select
              v-model="filters.status"
              clearable
            >
              <el-option
                label="待支付"
                value="1"
              ></el-option>
              <el-option
                label="支付成功"
                value="2"
              ></el-option>
              <el-option
                label="支付失败"
                value="3"
              ></el-option>
            </el-select>
          </el-form-item>


          <el-form-item>
            <el-button
              type="primary"
              @click="handleSearch"
            >搜索</el-button>

            <el-button
              style="margin-left:10px"
              @click="excelOut"
              type="primary"
              size="small"
            >导出</el-button>

          </el-form-item>

        </el-form>
      </div>

      <div class="contain_body">
        <!-- <div class="contain_body_head">
          总金额：{{totalMoney}}
        </div> -->
        <el-table
          v-loading="listLoading"
          :data="tableData"
          :height="tableHeight"
          style="width: 100%"
          :header-cell-class-name='objectSpanMethod'
        >


          <el-table-column
            prop="username"
            label="用户姓名"
          >
          </el-table-column>

          <el-table-column
            prop="telephone"
            label="手机号"
          >
          </el-table-column>

          <el-table-column
            prop="role_type"
            :formatter="formatterRoleType"
            label="代理身份"
          >
          </el-table-column>


          <el-table-column
            prop="create_time"
            label="创建时间"
          >
          </el-table-column>

          <el-table-column
            prop="pay_money"
            label="支付金额"
          >
          </el-table-column>

          <el-table-column
            prop="order_code"
            label="系统流水号"
          >
          </el-table-column>
          <el-table-column
            prop="pay_type"
            label="支付方式"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.pay_type == 1">支付宝</span>
              <span v-if="scope.row.pay_type == 2">微信</span>

              <span v-if="scope.row.pay_type == 4">支付宝</span>
              <span v-if="scope.row.pay_type == 5">微信</span>
              <span v-if="scope.row.pay_type == 6">余额</span>
              <span v-if="scope.row.pay_type == 7">绑卡快捷支付</span>
              <span v-if="scope.row.pay_type == 8">银行APP支付</span>
              <span v-if="scope.row.pay_type == 9">pos机收款</span>
            </template>
          </el-table-column>

          <el-table-column
            prop="third_code"
            label="支付流水号"
          >
          </el-table-column>

          <el-table-column
            prop="pay_time"
            label="支付时间"
          >
          </el-table-column>

          <el-table-column
          :formatter="formatterInfoType"
            prop="info_type"
            label="交易类型"
          >
          </el-table-column>

          <el-table-column
          :formatter="formatterPayType"
            prop="status"
            label="交易状态"
          >
          </el-table-column>

        </el-table>
        <div class="pageDiv block">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="page_num"
            :page-count='total_page'
            :page-size="page_size"
            layout="total, prev, pager, next"
            :total="total_num"
          >
          </el-pagination>
        </div>
      </div>

    </div>


  </el-main>
</template>


<script>
import { bus } from "../../bus.js";
import API from "../../api/api_user";
import { dateFunc } from "../../dateFunc";
var _ = require("lodash");
export default {
  name: "onLinePayList",
  created() {},
  data() {
    return {
      totalMoney: 0,
      listLoading: false,
      picList: [],
      filters: {
        status: '2',
        infoType:null,
        startTime: null,
        title: null,
        userId: null,
        endTime: null
      },
      page_num: 1,
      keywords: "",
      pickerOptions1: 1,
      tableData: [],
      total_num: 0,
      total_page: 0,
      page_size: 10,
      tableHeight:null
    };
  },
  mounted() {
    this.tableHeight = document.documentElement.clientHeight - 330;
    this.page_num = 1;
    this.handleSearch();
  },
  methods: {
    
    excelOut() {
      var that = this;
      var url =
        "/manager/user/pc/on_line_pay_list_excel?token=" +
        localStorage.getItem("api_token");
      if (that.filters.title) {
        url = url + "&userInfo=" + that.filters.title;
      } 
      if (that.filters.infoType) {
        url = url + "&infoType=" + that.filters.infoType;
      } 
      if (that.filters.status) {
        url = url + "&status=" + that.filters.status;
      } 
      if (that.filters.startTime) {
        url = url + "&startTime=" + that.filters.startTime.getTime();
      } else {
        that.$message.error({
          showClose: true,
          message: '请选择开始时间',
          duration: 2000
        });
        return;
      }
      if (that.filters.endTime) {
        url = url + "&endTime=" + that.filters.endTime.getTime();
      } else
      {
        that.$message.error({
          showClose: true,
          message: '请选择结束时间',
          duration: 2000
        });
        return;
      }
      top.location.href = url;
    },
    formatterRoleType(row, column) {
      var word = "";
      if (row.role_type == -1) {
        word = "无";
      } else if (row.role_type == -0.5) {
        return "康减系列vip会员";
      } else if (row.role_type == -0.4) {
        return "康减系列高级会员";
      } else if (row.role_type == -0.3) {
        return "康减系列荣誉会员";
      } else if (row.role_type == 0) {
        word = "VIP门店";
      } else if (row.role_type == 1) {
        word = "联盟店";
      } else if (row.role_type == 2) {
        word = "市代";
      } else if (row.role_type == 3) {
        word = "省代";
      } else if (row.role_type == 4) {
        word = "CEO";
      } else if (row.role_type == 1.1) {
        word = "康减系列市代";
      } else if (row.role_type == 2.1) {
        word = "康减系列省代";
      } else if (row.role_type == 3.1) {
        word = "康减系列CEO";
      } else if (row.role_type == 1.05) {
        return "优秀联盟店";
      } else if (row.role_type == 5) {
        return "总经销商";
      } else if (row.role_type == 2.2) {
        return "合伙人";
      } else if (row.role_type == 4.2) {
        return "董事";
      } else if (row.role_type == 5.1) {
        return "区域总监";
      } else if (row.role_type == 5.2) {
        return "城市加盟商";
      }  else if (row.role_type == 4.8) {
        return "经销商";
      }
      if (row.special_status == 2) {
        word = word + '-' + '特殊';
      }
      return word;
    },
    formatterPayType(row, column) {
      var word = "";
      if (row.status == 1) {
        word = "待支付";
      } else if (row.status == 2) {
        word = "支付成功";
      } else if (row.status == 3) {
        word = "支付失败";
      }
      return word;
    },
    formatterInfoType(row, column) {
      var word = "";
      if (row.info_type == 1) {
        word = "充值";
      } else if (row.info_type == 2) {
        word = "购进";
      } else if (row.info_type == 3) {
        word = "交保证金";
      } else if (row.info_type == 4) {
        word = "补交保证金";
      } else if (row.info_type == 5) {
        word = "发布服务订单";
      } else if (row.info_type == 6) {
        word = "加价服务订单";
      } else if (row.info_type == 9) {
        word = "补货";
      } else if (row.info_type == 16) {
        word = "支付学习费";
      } else if (row.info_type == 21) {
        word = "支付换货订单";
      } 
      return word;
    },
    handleSearch() {
      this.page_size = 10;
      this.page_num = 1;
      this.search();
    },
    search() {
      let that = this;
      let params = {
        pageNum: that.page_num,
        pageSize: that.page_size,
        token: localStorage.getItem("api_token")
      };
      if (that.filters.status) {
        params.status = that.filters.status;
      }
      if (that.filters.infoType) {
        params.infoType = that.filters.infoType;
      }
      if (that.filters.title) {
        params.userInfo = that.filters.title;
      }
      if (that.filters.startTime) {
        params.startTime = that.filters.startTime.getTime();
      } else {
        that.$message.error({
          showClose: true,
          message: '请选择开始时间',
          duration: 2000
        });
        return;
      }
      if (that.filters.endTime) {
        params.endTime = that.filters.endTime.getTime();
      } else {
        that.$message.error({
          showClose: true,
          message: '请选择结束时间',
          duration: 2000
        });
        return;
      }

      that.listLoading = true;
      API.on_line_pay_list(params)
        .then(
          function(result) {
            that.listLoading = false;
            if (result.key == 1000) {
              that.total_num = result.result.count;
              that.total_page = result.result.allPageNumber;
              if (result.result.list && result.result.list.length > 0) {
                for (var i = 0; i < result.result.list.length; i++) {
                  if (result.result.list[i].pay_time != null) {
                    result.result.list[i].pay_time = dateFunc.formatDate(
                      new Date(parseInt(result.result.list[i].pay_time)),
                      "yyyy-MM-dd hh:mm:ss"
                    );
                  }
                  result.result.list[i].create_time = dateFunc.formatDate(
                      new Date(parseInt(result.result.list[i].create_time)),
                      "yyyy-MM-dd hh:mm:ss"
                    );
                }
              }
              that.tableData = result.result.list;
            }
          },
          function(err) {
            that.listLoading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.listLoading = false;
          console.error(error);
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    jumpTo(url) {
      this.$router.push(url); //用go刷新
    },
    handleOpen(key, keyPath) {},
    handleClose(key, keyPath) {},
    handleClick(tab, event) {},
    objectSpanMethod({ row, rowIndex }) {
      return "table_head";
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.search();
    }
  }
};
</script>

<style>

.table_head {
  background-color: #f8f8f8 !important;
  border-right: 1px solid #eee;
  border-bottom: 1px solid #eee;
  border-top: 1px solid #eee;
}

.main_content {
  position: absolute;
  left: 210px;
  top: 105px;
  right: 0;
  bottom: 0;
  background-color: #f2f2f2;
  padding: 0;
}

.cont_navs {
  background-color: #fff;
  width: 100%;
  height: 55px;
  box-sizing: border-box;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  text-align: center;
  margin-bottom: 20px;
}
.cont_navs li {
  display: inline-block;
  line-height: 21px;
  padding: 17px 0;
  margin: 0 20px;
  height: 55px;
  color: #bbb;
  font-size: 15px;
  text-align: center;
  cursor: pointer;
}
.cont_navs li:hover {
  color: #409eff;
}

.ac_li {
  color: #409eff;
  border-bottom: solid 2px #409eff;
}
.contain_div {
  margin: 10px;
}
.cont_btns {
  float: right;
  margin: 0px 0px 20px 0;
}
.contain_header {
  background-color: #fff;
  padding: 10px;
}
.cont_btns li {
  display: inline-block;
}

.contain_body {
  background-color: #fff;
  margin-top: 20px;
  position: relative;
  padding-bottom: 35px;
}
.contain_body_head {
  display: block;
  padding: 10px 0 10px 10px;
  font-size: 16px;
  background-color: #f8f8f8;
}
.pageDiv {
  position: absolute;
  right: 0;
  bottom: 0;
}

.m-search {
  margin-bottom: -15px;
}
.el-button + .el-button {
  margin-left: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/dictionary/onLinePayList.vue